import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const DeleteFunction = async (url, id) => {
  try {
    const { data } = await axios.delete(`${BASE_URL}/${url}/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (data.statusCode === 200) {
      return toast.success("Deleted Successfully!!");
    } else {
      return toast.error("Something went wrong!!");
    }
  } catch (error) {
    console.log(error?.data?.response?.message);
  }
};

export default DeleteFunction;
